module.exports = __webpack_public_path__ + "img/iverson-reactjs.b06868ee.png";